import { Link } from "react-router-dom"
import { Button } from "@/components/ui/button"

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-muted/30 text-center">
      <h1 className="text-6xl font-semibold">404</h1>
      <p className="text-muted-foreground">Aradığın sayfa bulunamadı.</p>
      <Link to="/">
        <Button>Ana sayfaya dön</Button>
      </Link>
    </div>
  )
}
